import React, { useContext } from 'react';
import styled from 'styled-components';

import AnswerList from 'components/customer/answer_panel/search/answer_list';
import AnswerPanelContext from 'components/customer/answer_panel/answer_panel_context';

export default function AnswerSearchResults() {
  const { answersList, focusedAnswer, searchText } = useContext(AnswerPanelContext);

  return (
    <Results data-aid="answerPanel-searchResults">
      <AnswerList
        answers={answersList.answers}
        searchText={searchText}
        selectedAnswerId={focusedAnswer && focusedAnswer.id}
      />
    </Results>
  );
}

const Results = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`;
